<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">Distinta contanti</span>

  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    aria-label="Chiudi"
    class="close-button"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  <div class="cash-heading">
    <span class="body-medium">Incasso</span>
    <span class="body-medium-emphasized">{{ data.idIncasso }}</span>
  </div>

  @for (riga of righe; track riga.taglio) {
    <div class="cash-row">
      <span class="body-medium">{{ riga.descrizione }}</span>
      <span class="body-medium">Q.tà {{ riga.quantita }}</span>
      <span class="body-medium-emphasized">{{ formatAmount(riga.importo) }}</span>
    </div>
  }

  <div class="cash-row">
    <span class="body-medium">Monete</span>
    <span class="body-medium"></span>
    <span class="body-medium-emphasized">{{ formatAmount(data.totaleMonete) }}</span>
  </div>

  <div class="cash-total">
    <span class="label-medium-emphasized">Totale</span>
    <span class="label-medium-emphasized">{{ formatAmount(data.totale) }}</span>
  </div>
</mat-dialog-content>
